import React from 'react';
import { connect } from 'react-redux';
import { Route, Redirect } from 'react-router-dom';
import Profile from '../components/Profile';

export const PublicRoute = ({
  isAuthenticated,
  component: Component,
  ...rest
}) => {
//console.log('PublicRoute isAuthenticated', isAuthenticated, 'history', history)
  return (
    <Route {...rest} component={(props) => (
      isAuthenticated ? (
        
        <Component {...props} />
      ) : (
        
        <Component {...props} />
        )
    )} />
  )
};

const mapStateToProps = (state) => ({
  profile: state.globalState.profile,
  isAuthenticated: state.auth.isLoggedin,
  error: state.error.hasError
});


export default connect(mapStateToProps)(PublicRoute);



// WEBPACK FOOTER //
// ./src/routers/PublicRoute.js